export default {
  users: [],
  roles: [],
};
